import useSWR from "swr";

export enum DynamicPricingAdjustmentType {
  Percentage = "percentage_adjustment",
  Amount = "amount_adjustment",
}

interface DynamicPricingOption {
  unitPrice: number;
  adjustmentType: DynamicPricingAdjustmentType;
  adjustmentValue: number;
}

export interface DynamicPricingBulkHour extends DynamicPricingOption {
  type: "BulkHour";
  minBookingUnit: number;
}

interface DynamicPricingStartTime extends DynamicPricingOption {
  type: "StartTime";
  startTime: string;
  endTime: string;
}

interface DynamicRates {
  date: string;
  currentUnitPrice: number;
  originalUnitPrice: number;
  options: (DynamicPricingBulkHour | DynamicPricingStartTime)[];
}

export function useDynamicRatesQuery(
  spaceId?: string,
  date?: string,
  unitPrice?: number
): { data: DynamicRates | undefined } {
  const params = new URLSearchParams();
  date && params.set("date", date);
  unitPrice && params.set("current_unit_price", unitPrice.toString());
  const qs = params.toString();

  const { data } = useSWR(
    spaceId && date && unitPrice
      ? `/api/v2/spaces/${spaceId}/dynamic_rates/better_hour_rates?&${qs}`
      : null
  );

  return { data: toDynamicRates(data) };
}

function toDynamicRates(data?: any): DynamicRates | undefined {
  if (data) {
    return {
      date: data.date,
      currentUnitPrice: data.current_unit_price,
      originalUnitPrice: data.original_unit_price,
      options: data.options?.map(toDynamicRatesOption),
    };
  }
}

function toDynamicRatesOption(
  data?: any
): DynamicPricingBulkHour | DynamicPricingStartTime | undefined {
  if (data.min_booking_unit) {
    return {
      type: "BulkHour",
      unitPrice: data.unit_price,
      adjustmentType: data.adjustment_type,
      adjustmentValue: Number(data.adjustment_value),
      minBookingUnit: Number(data.min_booking_unit),
    };
  } else if (data.start_time && data.end_time) {
    return {
      type: "StartTime",
      unitPrice: data.unit_price,
      adjustmentType: data.adjustment_type,
      adjustmentValue: Number(data.adjustment_value),
      startTime: data.start_time,
      endTime: data.end_time,
    };
  }
}
